import { render, staticRenderFns } from "./CreateOrEditShop.vue?vue&type=template&id=52021d8e&scoped=true&"
import script from "./CreateOrEditShop.vue?vue&type=script&lang=js&"
export * from "./CreateOrEditShop.vue?vue&type=script&lang=js&"
import style0 from "./CreateOrEditShop.vue?vue&type=style&index=0&id=52021d8e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52021d8e",
  null
  
)

export default component.exports